import { useEffect, useState } from "react";
import { RelatoriosLayout } from "../../../layouts";
import { responseErros } from "../../../utils";
import {
  FormFiltroAvancado,
  FormFiltroAvancadoComissao,
  FormFiltroAvancadoServicosVendidos,
  FormFiltroAvancadoAnaliseAbcServicos,
} from "./components";
import {
  notification,
  ConfiguracoesService,
  OrdemServicoService,
} from "../../../services";
import { PrintContasReceberDetalhado } from "../layouts";
import { PermisoesHelper, responseStreamHelper } from "../../../helpers";
const ordemServicoService = new OrdemServicoService();
const configuracaoService = new ConfiguracoesService();

const RelatoriosServicos = () => {
  const permissoesHelper = new PermisoesHelper();
  const [loading, setLoading] = useState(false);
  const [configuracoes, setConfiguracoes] = useState({});
  const [filtrosAvancados, setFiltrosAvancados] = useState({});
  const [filtrosAplicadosImpressao, setFiltrosAplicadosImpressao] = useState(
    {},
  );

  const subgruposRelatoriosFinanceiros = [
    {
      subgrupo: "Ordem de Serviço",
      propriedades: [
        {
          name: "801 - Ordem de Serviço Resumido",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-ordem-servico-resumido",
          ),
          funcaoBuscarDadosRelatorio: buscarOrdemServicoResumido,
          formulario: FormFiltroAvancado,
        },
        {
          name: "802 - Ordem de Serviço Detalhado",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-ordem-servico-detalhado",
          ),
          funcaoBuscarDadosRelatorio: buscarOrdemServicoDetalhado,
          formulario: FormFiltroAvancado,
        },
        {
          name: "803 - Comissão de Serviços",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-ordem-servico-comissao",
          ),
          funcaoBuscarDadosRelatorio: buscarOrdemServicoComissao,
          formulario: FormFiltroAvancadoComissao,
        },
        {
          name: "804 - Serviços Vendidos",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-ordem-servico-servicos-vendidos",
          ),
          funcaoBuscarDadosRelatorio: buscarServicosVendidos,
          formulario: FormFiltroAvancadoServicosVendidos,
        },
        {
          name: "805 - Análise ABC de Serviços",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-ordem-servico-analise-abc-servicos",
          ),
          funcaoBuscarDadosRelatorio: buscarAnaliseAbcServicos,
          formulario: FormFiltroAvancadoAnaliseAbcServicos,
        },
        {
          name: "806 - Monitor de Ordem de Serviço",
          permissao: permissoesHelper.temPermisao(
            "relatorio-monitor-ordem-servico",
          ),
          dashboard: true,
          dashboardUrl: "/monitor-ordem-servico",
        },
      ],
    },
  ];

  useEffect(() => {
    buscarConfiguracoes();
  }, []);

  function buscarConfiguracoes() {
    configuracaoService.get().then((result) => {
      if (!result.isAxiosError) {
        setConfiguracoes((prevState) => ({
          ...prevState,
          jurosPorcentagem: result.data.rows[0]?.jurosPorcentagem ?? 0,
          multaPorcentagem: result.data.rows[0]?.multaPorcentagem ?? 0,
          carencia: result.data.rows[0]?.carencia ?? 0,
        }));
      }
    });
  }

  async function buscarOrdemServicoResumido(filtros) {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioResumido(filtros);
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function buscarOrdemServicoDetalhado(filtros) {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioDetalhado(filtros);
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function buscarOrdemServicoComissao(filtros) {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioComissaoPrestadores(
      filtros,
    );
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function buscarServicosVendidos(filtros) {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioServicosVendidos(
      filtros,
    );
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function buscarAnaliseAbcServicos(filtros) {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioAnaliseAbcServicos(
      filtros,
    );
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function openAbaRelatorio(blob) {
    try {
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  return (
    <RelatoriosLayout
      title="Relatório Contas a receber"
      subgruposRelatorios={subgruposRelatoriosFinanceiros}
      filtrosAplicadosImpressao={filtrosAplicadosImpressao}
      dadosRelatorioResumido={{}}
      setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
      filtrosAvancados={filtrosAvancados}
      setFiltrosAvancados={setFiltrosAvancados}
      loading={loading}
      configuracoes={configuracoes}
    />
  );
};

export default RelatoriosServicos;
